import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/take/bannerBase.png';
import _imports_1 from '@/assets/images/take/circle.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6c7878a4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "base-info"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "banner",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_3 = {
  key: 0,
  "class": "base-box base-form"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "请输入你的基本信息", -1);
});
var _hoisted_5 = {
  "class": "form-box"
};
var _hoisted_6 = {
  "class": "qs-item"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "qs-title"
  }, "1.请问您是否已满18周岁？", -1);
});
var _hoisted_8 = {
  "class": "qs-item"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "qs-title"
  }, "2、请问您是否正在怀孕、备孕、哺乳？", -1);
});
var _hoisted_10 = {
  "class": "qs-item"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "qs-title"
  }, "3、请问您是否有以下病史或家族史？", -1);
});
var _hoisted_12 = {
  key: 1,
  "class": "base-box base-result"
};
var _hoisted_13 = {
  "class": "r-title"
};
var _hoisted_14 = {
  "class": "r-qrcode flex-col items-center"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "咨询在线营养师", -1);
});
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "陪伴您更快更轻松地达到目标", -1);
});
var _hoisted_17 = ["src"];
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "banner",
    src: _imports_1,
    alt: ""
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;
  var _component_el_radio = _resolveComponent("el-radio");
  var _component_el_radio_group = _resolveComponent("el-radio-group");
  var _component_el_divider = _resolveComponent("el-divider");
  var _component_el_checkbox = _resolveComponent("el-checkbox");
  var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, $data.showForm ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
    modelValue: $data.form.age,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.age = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: 1
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("是")];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: 0
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("否")];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
    modelValue: $data.form.baby,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.baby = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: 1
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("是")];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: 0
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("否")];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.form.ill,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.ill = $event;
    }),
    onChange: $options.handleCheckedCitiesChange
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ills, function (ill) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: ill,
          key: ill
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(ill), 1)];
          }),
          _: 2
        }, 1032, ["label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_checkbox, {
    modelValue: $data.checkInvert,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.checkInvert = $event;
    }),
    onChange: $options.handleInvertCheckChange
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("以上均无")];
    }),
    _: 1
  }, 8, ["modelValue", "onChange"])])]), _createVNode(_component_el_divider), _createElementVNode("div", {
    "class": "nt-button",
    onClick: _cache[4] || (_cache[4] = function () {
      return $options.submit && $options.submit.apply($options, arguments);
    })
  }, "提交")])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($data.show1 ? "请按照医嘱进行用药" : "建议您进一步评估后再考虑使用该类药品，详情请咨询您的医生"), 1), _createElementVNode("div", _hoisted_14, [_hoisted_15, _hoisted_16, _createElementVNode("img", {
    "class": "wx",
    src: $data.scanImg.customerServiceImg,
    alt: ""
  }, null, 8, _hoisted_17)]), _createElementVNode("div", {
    "class": "nt-button",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return _this.showForm = true;
    })
  }, "返回")])), _hoisted_18]);
}